import { XCircle, MessageCircle, Home, RefreshCw } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export function PaymentFailed() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50 to-white flex flex-col">
      <Header />

      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-2xl w-full">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center size-24 bg-red-100 rounded-full mb-6">
              <XCircle className="size-16 text-red-600" />
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Sipariş Tamamlanamadı
            </h1>
            <p className="text-xl text-gray-600">
              Siparişiniz oluşturulurken bir hata oluştu.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-6">
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <p className="text-red-800 font-semibold mb-1">İşlem Başarısız</p>
              <p className="text-red-700 text-sm">
                Lütfen bilgilerinizi kontrol edip tekrar deneyin veya WhatsApp üzerinden bizimle iletişime geçin.
              </p>
            </div>

            <div className="bg-green-50 rounded-lg p-4 flex items-start gap-3">
              <MessageCircle className="size-5 text-green-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-green-900">
                Siparişler WhatsApp üzerinden tamamlanır. Checkout sayfasından tekrar deneyebilirsiniz.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <a
              href="/odeme"
              className="flex items-center justify-center gap-2 bg-pink-600 text-white px-6 py-4 rounded-lg font-semibold hover:bg-pink-700 transition-colors"
            >
              <RefreshCw className="size-5" />
              Tekrar Dene
            </a>
            <a
              href="/"
              className="flex items-center justify-center gap-2 bg-white text-gray-900 px-6 py-4 rounded-lg font-semibold border-2 border-gray-200 hover:border-pink-300 hover:bg-pink-50 transition-colors"
            >
              <Home className="size-5" />
              Ana Sayfaya Dön
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
